'use client';

import { c } from '../../../utils/tailwind-merge';
import { ButtonV2 } from '../../atoms/Button/Button.v2';
import { FavoriteListModal } from '../FavoriteListModal';
import type { ProductListNewActionsProps } from './ProductListHeader.types';

export const ProductListNewActions = ({
  microcopy,
  favoriteListModalProps,
  className = '',
  testId = 'product-list-new-actions',
}: ProductListNewActionsProps) => {
  return (
    <div className={c('flex items-center', className)} data-test={testId}>
      <FavoriteListModal
        {...favoriteListModalProps}
        trigger={
          <ButtonV2
            variant="secondary-blue-monochrome"
            size="large"
            shape="rounded"
            label={microcopy.new}
            iconLeft="Plus"
            iconWeight="bold"
            iconSize={undefined}
            iconClassName="h-5 w-5 !mr-1.5"
            aria-label={microcopy.newAria}
            data-test="product-list-header-new-button"
            className="w-full px-3 py-2 text-sm md:w-auto md:text-base lg:px-4 lg:py-3"
          />
        }
      />
    </div>
  );
};

ProductListNewActions.displayName = 'ProductListNewActions';
